import React, { useEffect, useState } from 'react'
import { Card, Table } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import Loader from './Loader/Loader';
import PaginationC from './pagination';

const DropMail = (props) => {

    const serverURL = getServerURL()
    const [searchText, setSearchText] = useState("");
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true);
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)

    useEffect(() => {
        getEngraveList();
    }, [searchText, page]);

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    const getEngraveList = (event) => {
        api.getWithToken(`${serverURL}drop-mail/?page=${page}${searchText && `&_s=${searchText}`}`)
            .then(async (res) => {
                setLoading(false)
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                if (res?.data?.success === true) {
                    setData(data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                                <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover className='product-table'>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Name</th>
                                <th>Recipient Email</th>
                                <th>Email</th>
                                <th>Notes</th>
                                <th>Email Update</th>
                                <th>Product</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>
                                    <tr key={index + "productShape"}>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <h6 className="m-0">{item?.name || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.recipient_email || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.email || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.notes || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.email_update?.toString() || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.product || "-"}</h6>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={6} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />}
        </>
    )
}

export default DropMail